import React, { Component } from 'react';
import { connect } from 'react-redux';

import BlueWindow from './blue-window';
import ErrorPage from './error-page';
import ErrorModal from './error-modal';
import ModalErrorTotem from './modal-error-totem';
import ErrorType from '../../../scripts/constants/errorList.js';
import ErrorPaymentLimitExceed from './error-payment-limit-exceed';
import ErrorPaymentFareNotAvailable from './error-payment-fare-not-available';
import ErrorNonEmissionChargeModal from './error-non-emission-charge.jsx';
import { getErrorMessage } from '../../../redux/actions/index';

import { sendAnalytics } from '../../../scripts/analytics/tracker';
import manageTracking from '../../../scripts/analytics/creators/manage';

const mapStateToProps = state => ({
  apiError: state.Manage.apiError || state.Login.apiError || state.UserProfileSession.apiError,
  country: state.Manage.country,
  dataPnrToLoad: state.Manage.dataPnrToLoad,
  errorLanguageBundle: state.LanguageBundle.errorLanguageBundle,
  errorMessageCms: state.ErrorMessage.errorMessageCms,
  errorMessageCmsFail: state.ErrorMessage.errorMessageCmsFail,
  language: state.Manage.language,
  loadingErrorMessage: state.ErrorMessage.loadingErrorMessage,
  loadingLanguageBundle: state.LanguageBundle.loadingLanguageBundle,
  loadingPNR: state.Manage.loadingPnrInfo,
  loadingStoreFront: state.StoreFront.loadingStoreFront,
  redirectError: state.Manage.redirectError,
  stateStoreFront: state.Manage.stateStoreFront,
});

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorInfo: null,
      errorUI: null,
      hasError: false,
      prevError: false,
    };
  }

  componentWillMount() {
    const {
      apiError,
      dispatch,
      errorLanguageBundle,
      language,
      loadingLanguageBundle,
      loadingStoreFront,
    } = this.props;

    const isGeneralLoading = loadingStoreFront || loadingLanguageBundle || errorLanguageBundle;

    if (apiError !== null && !isGeneralLoading) {
      dispatch(getErrorMessage('302045', language));

      this.setState({
        hasError: true,
        prevError: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      apiError,
      dispatch,
      errorLanguageBundle,
      language,
      loadingLanguageBundle,
      loadingStoreFront,
      redirectError,
    } = this.props;

    const isGeneralLoading = loadingStoreFront || loadingLanguageBundle || errorLanguageBundle;

    if (
      (nextProps.apiError !== apiError ||
        (apiError && nextProps.apiError && apiError?.errorData?.code !== nextProps.apiError?.errorData?.code))
      && !isGeneralLoading && nextProps.apiError !== null
    ) {
      dispatch(getErrorMessage(nextProps.apiError?.errorData?.code, language));

      this.setState({
        hasError: true,
        prevError: true,
      });
    } else {
      this.setState({
        prevError: false,
      });
    }

    if (nextProps?.apiError === null || apiError?.errorData?.codeAction === 'noneAction') {
      this.setState({
        hasError: false,
      });
    }

    if (redirectError !== nextProps.redirectError && nextProps.redirectError) {
      const errorInfo = {
        actionType: 'RETRIEVE_CURRENCY_REDIRECT',
        errorData: {
          code: '305005|400|RETRIEVE_CURRENCY_REDIRECT',
          actionable: 'ABORT',
          msg: 'INVALID',
          extraInfo: {
            'debugging_stuff_here': window.location.href,
          },
        },
      };
      dispatch(sendAnalytics({
        eventCreator: manageTracking.errorTracking(errorInfo),
      }));

      this.setState({
        hasError: true,
        prevError: true,
      });
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      errorInfo,
      errorUI: error,
      hasError: true,
      prevError: true,
    });
  }

  render() {
    const {
      apiError,
      children,
      country,
      dataPnrToLoad,
      dispatch,
      errorMessageCms,
      language,
      redirectError,
      stateStoreFront: {
        contactNumber,
      },
    } = this.props;
    const {
      errorInfo,
      errorUI,
      hasError,
      prevError,
    } = this.state;

    const errorTitle = 'WERE_SORRY';
    const upgradeVoucherFailAction = ['SET_UPGRADE_VOUCHER_FAIL'].includes(apiError?.actionType);
    const noErrorCode = (upgradeVoucherFailAction && apiError?.errorData === null) && 'abortModal';
    const errorCode = apiError?.errorData?.codeAction ? apiError?.errorData?.codeAction : apiError?.errorData?.code ? apiError?.errorData?.code : redirectError ? redirectError && '305005' : noErrorCode;
    const errorType = errorUI ? 'ErrorUI' : ErrorType[errorCode];
    const errorMessage = errorMessageCms?.errorMessages?.[0]?.errorMessage?.copy;
    let errorComponent = children;
    const isUpgradeVoucherRedeemedError = apiError?.actionType === 'SET_UPGRADE_VOUCHER_FAIL' && apiError?.errorData?.statusCode === 200;

    if ((errorCode === 'noneAction' && apiError?.errorData && !isUpgradeVoucherRedeemedError) || apiError?.errorData?.code === 503) {
      dispatch(sendAnalytics({
        eventCreator: manageTracking.errorTracking(apiError),
      }));
    }

    if (hasError) {
      switch (errorType) {
        case 'ErrorPage':
          errorComponent = !(apiError && apiError.actionType === 'SUBMIT_PAYMENT_FAIL') &&
            <ErrorPage
              apiError={ apiError }
              dispatch={ dispatch }
              errorMessage={ errorMessage }
              errorTitle={ errorTitle }
              errorUI={ errorUI }
            />;
          break;
        case 'ErrorModal':
          errorComponent = (<ErrorModal
            apiError={ apiError }
            dataPnrToLoad={ dataPnrToLoad }
            dispatch={ dispatch }
            errorMessage={ errorMessage }
            language={ language }
            country={ country }
            prevError={ prevError }>
            { children }
          </ErrorModal>);
          break;
        case 'ErrorModalTotem':
          errorComponent = !prevError &&
            <ModalErrorTotem>{ children }</ModalErrorTotem>;
          break;
        case 'ErrorModalPaymentLimit':
          errorComponent = <ErrorPaymentLimitExceed>{ children }</ErrorPaymentLimitExceed>;
          break;
        case 'ErrorModalPaymentFare':
          errorComponent = <ErrorPaymentFareNotAvailable>{ children }</ErrorPaymentFareNotAvailable>;
          break;
        case 'ErrorUI':
          errorComponent = (<BlueWindow
            contactNumber={ contactNumber }
            dispatch={ dispatch }
            errorInfo={ errorInfo }
            errorUI={ errorUI } />);
          break;
        case 'ErrorNonEmissionChargeModal':
          errorComponent = (<ErrorNonEmissionChargeModal
            apiError={ apiError }
            dataPnrToLoad={ dataPnrToLoad }
            dispatch={ dispatch }
            errorMessage={ errorMessage }
            language={ language }
            country={ country }
            prevError={ prevError }>
            { children }
          </ErrorNonEmissionChargeModal>);
          break;
        case 'ErrorModalPayment':
        default:
          errorComponent = children;
          break;
      }
    }

    return errorComponent;
  }
}

ErrorBoundary = connect(mapStateToProps)(ErrorBoundary);
export default ErrorBoundary;
